import { Component, OnInit, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';

import { User } from '../models/user';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    errorMessage = '';

    loginForm: FormGroup;

    constructor(private afAuth: AngularFireAuth,
        private router: Router,
        private formBuilder: FormBuilder,
        private ngZone: NgZone) { }

    ngOnInit() {

        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        this.afAuth.user.subscribe(user => {
            if (user) {
                this.ngZone.run(() => {
                    this.router.navigate(['/temporadas']);
                })
            }
        })
    }

    signIn() {
        this.afAuth.signInWithEmailAndPassword(this.loginForm.value.username, this.loginForm.value.password).then(() => {
            this.router.navigate(['/temporadas']);
        }).catch(response => {
            this.errorMessage = response.message;
        });
    }

    resetPassword() {
        if (!this.loginForm.value.username) {
            alert('Debes rellenar el email.');
        }
        this.afAuth.sendPasswordResetEmail(this.loginForm.value.username)
            .then(
                () => alert('Se ha enviado un email para reestablecer la contrase�a.'), 
                    (rejectionReason) => alert(rejectionReason))
                    .catch(e => alert('Ha ocurrido un error al tratar de reestabecer tu contrase�a.')); 
    }

}